export const sendClickEventToInsights = (category, label, value, version, action = 'click-result') => {
  window.adInsights.e(category, action, label, value, version)
}

export const insightsAttrs = ({ category = '', label = '', value, version }) => ({
  'data-insights-category': category,
  'data-insights-label': label,
  ...(value ? { 'data-insights-value': value } : {}),
  ...(version ? { 'data-insights-version': version } : {})
})
